import { useState, useEffect } from "react";
import JsxParser from 'react-jsx-parser';
import StaffNav from "./managernav";

export default function CourseViewer({ courseDocName }) {
  const [trainingDocuments, setTrainingDocuments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const [documentsPerPage] = useState(1); // Number of documents per page (adjust this value)
  const [pagesViewed, setPagesViewed] = useState(0); // Track how many pages have been viewed

  const token = localStorage.getItem('token');

  console.log(courseDocName);

  useEffect(() => {
    const fetchTrainingDocuments = async () => {
      try {
        const response = await fetch(`https://api.insightos.co.uk/api/courseviewer/${courseDocName}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',

          },
          credentials : 'include',

        });

        if (response.ok) {
          const data = await response.json();
          const sortedDocuments = data.data.sort((a, b) => a.Page - b.Page); // Sort documents by page
          setTrainingDocuments(sortedDocuments);
        } else {
          console.error('Failed to fetch training documents');
        }
      } catch (error) {
        console.error('Error:', error);
      }
    };

    fetchTrainingDocuments();
  }, [courseDocName]);

  // Get the documents for the current page
  const indexOfLastDocument = currentPage * documentsPerPage;
  const indexOfFirstDocument = indexOfLastDocument - documentsPerPage;
  const currentDocuments = trainingDocuments.slice(indexOfFirstDocument, indexOfLastDocument);

  // Handle Next button click
  const nextPage = () => {
    if (currentPage < Math.ceil(trainingDocuments.length / documentsPerPage)) {
      setCurrentPage(currentPage + 1);
      setPagesViewed(pagesViewed + 1); // Increment pages viewed
    }
  };

  // Handle Previous button click
  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      setPagesViewed(pagesViewed - 1); // Decrement pages viewed
    }
  };

  // Calculate progress percentage
  const progressPercentage = (currentPage / Math.ceil(trainingDocuments.length / documentsPerPage)) * 100;

  return (
   <>
        <div className="flex items-center justify-center min-h-screen bg-gray-100 p-2 sm:p-4">
            
        <div className="w-full max-w-full min-h-screen p-4 sm:p-6 lg:p-8 border rounded-lg bg-white shadow-lg overflow-auto">
       
        {/* Course Content */}
        <div className="flex flex-col items-center justify-center flex-grow overflow-y-auto mb-6">
          <div className="w-full">
            {currentDocuments.map((doc, index) => (
              <div key={index} className="w-full mb-4 p-3 sm:p-4 bg-gray-50 rounded-lg border">
                <div className="prose prose-sm sm:prose-base max-w-none">
                  <JsxParser components={{}} jsx={doc.Code} />
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Navigation Buttons */}
        <div className="flex flex-col sm:flex-row justify-between items-stretch sm:items-center gap-3 sm:gap-4 mt-6">
          <button
            onClick={prevPage}
            disabled={currentPage === 1}
            className="w-full sm:w-auto px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200 font-medium"
          >
            ← Previous
          </button>
          <div className="flex-1 text-center">
            <span className="text-sm sm:text-base text-gray-600 font-medium">
              Page {currentPage} of {Math.ceil(trainingDocuments.length / documentsPerPage)}
            </span>
          </div>
          <button
            onClick={nextPage}
            disabled={currentPage >= Math.ceil(trainingDocuments.length / documentsPerPage)}
            className="w-full sm:w-auto px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200 font-medium"
          >
            Next →
          </button>
        </div>

        {/* Progress Display */}
        <div className="mt-6 space-y-3">
          {/* Progress Bar */}
          <div className="w-full bg-gray-200 rounded-full h-3">
            <div 
              className="bg-blue-600 h-3 rounded-full transition-all duration-300 ease-out"
              style={{width: `${Math.min(progressPercentage, 100)}%`}}
            ></div>
          </div>
          
          {/* Progress Text */}
          <div className="text-center space-y-1">
            <p className="text-sm sm:text-base font-semibold text-gray-800">
              Progress: {Math.min(progressPercentage, 100).toFixed(1)}%
            </p>
            <p className="text-xs sm:text-sm text-gray-500">
              Pages Viewed: {pagesViewed} / {Math.ceil(trainingDocuments.length / documentsPerPage)}
            </p>
          </div>
        </div>
        {/* Pagination Controls */}
        
      </div>
    </div>
    </>
  );
}
